<template>
  <v-layout row justify-center>
    <v-dialog v-model="params.show" max-width="600px" persistent>
      <v-form id="newSlipForm">
        <v-card>
          <v-card-title>
            <span class="headline">Boleto de Recarga</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Valor à ser creditado"
                    v-model="params.bill.value"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="params.show = false">Fechar</v-btn>
            <v-btn
              color="primary"
              :loading="params.loadingButton"
              @click="submitNewSlip"
            >Gerar Boleto</v-btn>
          </v-card-actions>
          <!-- <v-progress-linear :indeterminate="true"></v-progress-linear> -->
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="params.dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Boleto Gerado com Sucesso</v-card-title>
        <v-card-text> Seu Boleto foi emitido e enviado ao seu e-mail. Você também pode clicar no botão abaixo para baixar o PDF.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click="params.dialog = false">Fechar</v-btn>
          <v-btn color="info" @click="downloadPdfBill">Baixar Boleto PDF</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="params.dialogErrors" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ this.billErrors.mensagem }}</v-card-title>
        <v-card-text>{{ this.billErrors.desenvolvedor.mensagem }}</v-card-text>
        <v-card-actions>
          <v-btn color="red" block center @click="params.dialogErrors = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  name: "SelfSlipRecharge",

  created() {
    this.$store.dispatch('account/getAccount');
    this.$store.dispatch('system/fetchSystemConfiguration');
    EventBus.$on('show-self-slip-recharge', () => {
      this.params.show = true;
    });
  },
  computed: {
    ...mapGetters({
      account: 'accoun/account',
      partnerName: 'account/partnerName',
      createdBill: 'wallet/bill',
      billErrors: 'wallet/billErrors',
      systemAppName: 'system/appName',
    })
  },
  watch: {
    createdBill(newValue, oldValue) {
      this.params.dialog = true;
      this.params.show = false;
      this.params.loadingButton = false;
    },
    billErrors(newValue, oldValue) {
      this.params.dialogErrors = true;
      this.params.show = false;
      this.params.loadingButton = false;
    }
  },
  data: () => ({
    params: {
      show: false,
      dialog: false,
      dialogErrors: false,
      loadingButton: false,
      bill: {
        value: 0
      }
    }
  }),
  methods: {
    submitNewSlip() {
      this.$store.dispatch('wallet/selfSlipRecharge', this.params.bill);
      this.params.loadingButton = true;
    },
    downloadPdfBill() {
      const link = document.createElement('a');
      // link.href = 'data:application/octet-stream;base64,' + this.createdBill.pdfBinario;
      link.href = `data:application/octet-stream;base64,${this.createdBill.pdfBinario}`;
      link.download = `boleto_${this.systemAppName || process.env.VUE_APP_APP_NAME || 'flowit'}_${Date.now()}.pdf`;
      link.click();
    },
  },
};
</script>
